.mo-offer-frame-overlay {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  cursor: pointer;
  display: inherit;
}

.mo-offer-frame-overlay .mo-offer-frame-overlay__container {
  width: 85vw;
  height: fit-content;
  position: absolute;
  top: 10vh;
  left: 10vw;
  border-radius: 15px;
  background-color: #ffffff;
}

#mo-offer-iframe {
  order: none;
  width: 100%;
  height: 80vh;
  overflow: hidden;
  border: 15px;
  border-radius: 15px;
}

.close-icon {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 20px;
  right: 20px;
}
